import React, { useEffect, useState } from 'react';
import { generateSignin } from '../core/product_page/apiProduct';
import { isAuthenticated } from '../auth';
import { APP_URL } from '../config';

const LinkPaypal = () => {
    const { user: {_id, email}, token } = isAuthenticated();
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        console.log(APP_URL);
        generateSignin(email, APP_URL+'/add-loot', _id).then(data => {
            setLoading(false);
            console.log(data);
            setUrl(data.links[1].href)
        });
    },[]);

   return (
    <div className="bg-indigo-50">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="">
          <span className="block text-3xl font-extrabold tracking-tight text-gray-900 md:text-4xl ">Connect your PayPal account to continue</span>
          <p className='text-md text-gray-500'>Connect your account in order to recieve cash and partial cash payments</p>
        </h2>
        <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <a
              href={`${url}`}
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
                {loading ? 
                    <>
                        Loading...
                    </>
                    :
                    <>
                        Connect PayPal
                    </>
                }
            </a>
          </div>
        </div>
      </div>
    </div>
  )
};

export default LinkPaypal;
